<template>
  <div>
    <div
      class="profile-field__title"
      :class="{
        'profile-field__title--required': field.required,
      }"
    >
      Документы
    </div>
    <div class="wrapper">
      <div class="snils">
        <c-input
          v-model="snils"
          label="СНИЛС"
          :clearable="true"
          placeholder="___-___-___-__"
          mask="###-###-###-##"
          :invalid="error && (error.common || error.snils)"
          :error="error && error.snils"
        />
      </div>
      <div class="inn">
        <c-input
          v-model="inn"
          floating-label="ИНН"
          type="price-number"
          :max-length="30"
          :fractional-length="0"
          :clearable="true"
          :invalid="error && (error.common || error.inn)"
          :error="error && error.inn"
        />
      </div>
    </div>

    <error-feedback v-if="error && error.common" :text="error && error.common" />
  </div>
</template>

<script>
import CInput from "@/components/controls2/Input";
import ErrorFeedback from "@/components/error-feedback";

export default {
  components: { CInput, ErrorFeedback },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      snils: "",
      inn: "",
    };
  },

  watch: {
    snils() {
      this.updateValue();
    },
    inn() {
      this.updateValue();
    },
    value(v) {
      this.setData(v);
    },
  },

  created() {
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;
      const { snils, inn } = value.value || {};
      this.snils = snils || "";
      this.inn = inn || "";
      this.$nextTick(() => {
        this.inited = true;
      });
    },
    updateValue() {
      this.$emit("input", {
        value: {
          snils: this.snils,
          inn: this.inn,
        },
      });
      if (this.inited) this.$emit("change");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.wrapper {
  margin-left: -8px;
  margin-right: -8px;
  display: flex;
}
.snils,
.inn {
  padding-left: 8px;
  padding-right: 8px;
  width: 50%;
}
.snils {
  padding-top: 6px;
}

@include bootstrapMd {
  .wrapper {
    margin-left: -15px;
    margin-right: -15px;
  }
  .snils,
  .inn {
    padding-left: 15px;
    padding-right: 15px;
    width: calc(100% / 10 * 2);
  }
}

@include bootstrapLg {
  .snils,
  .inn {
    width: calc(100% / 12 * 2);
  }
}
</style>
